var model = require('model/model');
var pubsub = require('events/pubsub');
var scrollPositions = {};
var $window = $(window);
var $page = $('html, body');
var Q = require('q');

pubsub.subscribe('route-changing', function (data, oldData) {
	let oldURI = oldData.p + oldData.h;
	scrollPositions[oldURI] = $window.scrollTop();
});

var pageDescriptionDefault =
	'ReadWorks is an edtech nonprofit organization that is committed to helping to solve America’s reading comprehension crisis.';

module.exports = {
	install: function (Vue, options) {
		Vue.prototype.$ = function (selector) {
			return $(selector, this.$el);
		};

		Vue.prototype.$watchModel = function (name, cb) {
			let remove = model.change(name, cb);
			this._ownables.push(remove);
			return () => {
				let filteredOwnables = this._ownables.filter(o => o !== remove);
				// Make sure component hasn't already been torn down and cb removed
				//  and that the function we want to remove is present
				if (this._ownables.length && this._ownables.length !== filteredOwnables.length) {
					// Remove function from ownables
					this._ownables = filteredOwnables;
					// model.change remove
					return remove();
				}
				return null;
			};
		};

		Vue.prototype.own = function () {
			this._ownables.push.apply(this._ownables, arguments);
		};

		Vue.prototype.restoreScrollPosition = function () {
			return Q.ninvoke(
				$page,
				'animate',
				{
					scrollTop: scrollPositions[window.location.pathname + window.location.hash]
				},
				{
					duration: 0
				}
			);
		};

		Vue.prototype._eachModelDataMapping = function (cb) {
			var modelData = this.$options.modelData;
			if (!modelData) {
				return;
			}

			if (Array.isArray(modelData)) {
				modelData.forEach(
					function (name) {
						cb(name, name);
					}.bind(this)
				);
			} else {
				Object.keys(modelData).forEach(
					function (modelName) {
						var dataName = modelData[modelName];
						cb(modelName, dataName);
					}.bind(this)
				);
			}
		};

		Vue.prototype.isModelNameMappedToData = function (modelName) {
			return !!this._modelNamesMappedToData[modelName];
		};

		Vue.mixin({
			created: function () {
				this._ownables = [];
				this._modelNamesMappedToData = {};

				var watchingObjects = {};

				// watch model, when it changes update $data
				this._eachModelDataMapping(
					function (modelName, dataName) {
						this._modelNamesMappedToData[modelName] = dataName;

						this.$watchModel(
							modelName,
							function (v) {
								const splitName = dataName.split('.');
								const { objectToSet, key } = splitName.reduce(
									(acc, stepKey, index) => {
										const isLast = index === splitName.length - 1;
										const toSet = isLast ? acc.objectToSet : acc.objectToSet[acc.key];

										return {
											objectToSet: toSet,
											key: stepKey
										};
									},
									{
										objectToSet: this,
										key: splitName[0]
									}
								);
								Vue.set(objectToSet, key, v);
							}.bind(this)
						);

						if (dataName.indexOf('.') === -1) {
							// watch $data, when it changes update model,
							// but only if model doesn't match, this way we avoid
							// an infinite loop
							this.$watch(
								dataName,
								function (dataValue) {
									var v = model.get(modelName);
									if (dataValue !== v) {
										model.set(modelName, dataValue);
									}
								}.bind(this)
							);
						} else {
							var propertyTokens = dataName.split('.'),
								objectName = propertyTokens[0];

							if (!watchingObjects[objectName]) {
								this.$watch(
									objectName,
									function (val) {
										var pairs = {};

										for (var key in val) {
											if (watchingObjects[objectName][key] && pairs[key] !== val[key]) {
												pairs[key] = val[key];
											}
										}

										if (pairs && Object.keys(pairs).length) {
											model.set(pairs);
										}
									},
									{
										deep: true
									}
								);

								watchingObjects[objectName] = {};
							}

							watchingObjects[objectName][propertyTokens[1]] = true;
						}
					}.bind(this)
				);
			},

			data: function () {
				var data = {};

				this._eachModelDataMapping(
					function (modelName, dataName) {
						data[dataName] = null;
					}.bind(this)
				);

				return data;
			},
			beforeDestroy: function () {
				if (typeof this._titleWatcher === 'function') {
					this._titleWatcher();

					this._titleWatcher = null;
				}
				if (typeof this._pageDescriptionWatcher === 'function') {
					this._pageDescriptionWatcher();

					this._pageDescriptionWatcher = null;
				}

				this._ownables.forEach(function (f) {
					f();
				});
				this._ownables = [];
			},
			mounted() {
				if (this.$options.name && this.$options.name.indexOf('route-') === 0) {
					if (typeof this.titleOverride !== 'undefined') {
						document.title = this.titleOverride;
					} else if ('title' in this) {
						this._titleWatcher = this.$watch(
							'title',
							function (title) {
								if (title) {
									document.title = title;
								}
							},
							{
								immediate: true
							}
						);
					} else {
						document.title = 'ReadWorks | Award-Winning, EdTech Nonprofit Organization';
					}

					if ('pageDescription' in this) {
						this._pageDescriptionWatcher = this.$watch(
							'pageDescription',
							function (description) {
								let updatedDescription = pageDescriptionDefault;
								if (description) {
									updatedDescription = description;
								}
								this.updatePageDescription(updatedDescription);
							},
							{
								immediate: true
							}
						);
					} else {
						this.updatePageDescription(pageDescriptionDefault);
					}
				}
			},
			methods: {
				updatePageDescription: function (description) {
					$('meta[name=description]').attr('content', description);
				}
			}
		});

		// integrate subscribe and subscribeOnce similar to $on and $once
		Vue.prototype.$subscribe = function (name, cb) {
			var off = pubsub.subscribe(name, cb);
			this._ownables.push(off);
			return off;
		};

		// provided more for convenience and uniformity, since subscribeOnce doesn't
		// need to be in _ownables
		Vue.prototype.$subscribeOnce = function (name, cb) {
			var off = pubsub.subscribeOnce(name, cb);
			this._ownables.push(off);
			return off;
		};
	}
};
